





































































































import { Component } from 'vue-property-decorator';
import { accountReceivableService, depositLogService, voiceCallService } from '@/shared';
import { Base } from './base';
import { IDialogOption } from '@/models/dialog';
import { mask } from 'vue-the-mask';
import { Countries } from '@/helper/countries';
import { Utils } from '@/helper/utils';

@Component({
  computed: {},
  components: {
    AppDialog: () => import('@/components/common/app.dialog.vue'),
    CardAddressDetails: () =>
      import('@/components/common/cards.address.details.vue'),
    SnackBarLoader: () => import('@/components/common/loader.vue'),
  },
  props: ['customerKeyValue'],
  directives: {
    mask,
  },
})
class CardsAddressDetails extends Base {
  public errors!: any;
  public cardSubmitUrl: string = Utils.WEB_BASE_URL;
  public addcustomerModel: any = {
    customerKey: '',
    customerName: '',
    addressLine: '',
    stateCode: '',
    city: '',
    country: '',
    email: '',
    phoneNumber: '',
    zipCode: '',
  };

  public suqareCountries = Countries.counties;
  public showAddCardDetails: boolean = false;
  public currentUrl: string = '';

  // public cardDetailsInfo: any = {
  public customerKey = '';
  public tenantId = '';
  public enterpriseId = '';
  public storeId = '';
  public returnUrl = '';
  public customerName = '';
  public updateDialog: boolean = false;
  public cardDetailsInfo: any = {
    customerKey: '',
    tenantId: '',
    enterpriseId: '',
    storeId: '',
    returnUrl: '',
    customerName: '',
    city: '',
    state: '',
    zipCode: '',
    country: '',
    email: '',
    address: '',
    firstName: '',
    lastName: '',
    phone: '',
    loggedInUserId: ''
  };

  // public customerKey = '';
  public cardDetailsLoading: boolean = false;
  public customerSearch: boolean = false;
  public defaultPaymentProvider: string = '';
  public isOutOfSync: boolean = false;

  public addCustomerDialog: IDialogOption = {
    width: 500,
    title: 'Add Address Details For Card',
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: 'Add Address Details For Card',
      disable: false,
    },
    onAction: (): void => {
      this.addCustomer();
    },
    onClose: (): void => {
      this.onClose();
    },
  };

  public async mounted() {

    this.$watch(
      "addcustomerModel",
      (newVal) => {
        this.cardDetailsInfo.country = newVal.country;
        this.cardDetailsInfo.zipCode = newVal.zipCode;
        this.cardDetailsInfo.city = newVal.city;
        this.cardDetailsInfo.address = newVal.addressLine;
        this.cardDetailsInfo.email = newVal.email;
        this.cardDetailsInfo.phone = newVal.phoneNumber;
      },
      {
        deep: true, // Enables deep watching
      }
    );
    this.cardDetailsInfo.customerKey = this.$props.customerKeyValue;
    this.cardDetailsInfo.tenantId = this.userSession.tenantId;
    this.cardDetailsInfo.enterpriseId = this.userSession.enterpriseId;
    this.cardDetailsInfo.storeId = this.userSession.storeId;
    this.cardDetailsInfo.loggedInUserId = this.userSession.sessionUserId;
    this.currentUrl = window.location.href;
    await this.getPaymentProviderDetails();
    this.openSquareCard(this.cardDetailsInfo.customerKey);
  }
  public async getPaymentProviderDetails() {

    this.customerSearch = true;
    try {

      const result = await depositLogService.getDefaultPaymentProvider(
        this.userSession.storeId
      );
      this.defaultPaymentProvider = result.paymentProvider;
      if (this.defaultPaymentProvider == "Square") {
        this.cardSubmitUrl += '/serverpay/square/card';
      } else if (this.defaultPaymentProvider == "Payroc") {
        this.cardSubmitUrl += '/serverpay/payroc/card';
      } else if (this.defaultPaymentProvider == "AuthorizeNet") {
        this.cardSubmitUrl += '/serverpay/authorizeNet/card';
      } else if (this.defaultPaymentProvider == "Redrock") {
        this.cardSubmitUrl += '/serverpay/redrock/card';
      }
    }
    catch (e) {
      console.error(e.message);
    }

  }
  public onClose() {
    this.$emit('updateCard', false);
  }

  public async continueWithoutUpdate() {
    var form = document.getElementById('squareFormSubmit');
    form.click();

  }
  public async openSquareCard(customerKey) {
    try {
      this.customerSearch = true;
      var res = await accountReceivableService.getSquareCustomer(customerKey);

      this.cardDetailsInfo.customerName = [res?.lastName, res?.firstName].filter(Boolean).join(' ');

      var result = document.getElementById('customerName') as any;
      result.value = this.cardDetailsInfo.customerName;

      this.cardDetailsInfo = {
        ...this.cardDetailsInfo,
        zipCode: res.zipCode,
        country: res.county,
        email: res.email1,
        city: res.city,
        address: res.address1,
        phone: res.phoneNumber,
        firstName: res.firstName,
        lastName: res.lastName
      };
      if (res.isSuccess && !res.isOutOfSync) {
        //Customer exists and is synced, open hosted field page for card update directly
        var form = document.getElementById('squareFormSubmit');
        form.click();
      } else {
        this.addcustomerModel.customerKey = res.customerNumber;
        this.addcustomerModel.customerName = res.lastName + ' ' + res.firstName;
        this.addcustomerModel.addressLine = res.address1;
        this.addcustomerModel.stateCode = res.stateCode;
        this.addcustomerModel.city = res.city;
        this.addcustomerModel.email = res.email1;
        this.addcustomerModel.phoneNumber = res.phoneNumber;
        this.addcustomerModel.zipCode = res.zipCode;
        this.isOutOfSync = res.isOutOfSync;
        if (this.isOutOfSync) {
          this.addCustomerDialog = {
            width: 700,
            title: this.defaultPaymentProvider == "Square" ? 'Customer Details Out Of Sync With Square and Alynk' : this.defaultPaymentProvider == "Payroc" ? 'Customer Details Out Of Sync With Payroc and Alynk' : 'Customer Details Out Of Sync With Redrock and Alynk',
            model: false,
            loading: false,
            action: {
              color: 'success',
              icon: 'fas fa-check',
              text: 'Update And Continue',
              disable: false,
            },
            onAction: (): void => {
              this.addCustomer();
            },
            onClose: (): void => {
              this.onClose();
            }
          };
        }
        this.addCustomerDialog.model = true;
        this.cardDetailsLoading = true;

      }
    } finally {
      this.cardDetailsLoading = false;
      this.customerSearch = false;
    }
  }

  public async addCustomer() {

    if (await this.validateForm()) {
      try {
        this.addCustomerDialog.action.disable = true;
        this.addcustomerModel.isOutOfSync = this.isOutOfSync;
        var res = await accountReceivableService.createSquareCustomer(
          this.addcustomerModel
        );
        this.cardDetailsInfo.customerKey = this.addcustomerModel.customerKey;
        this.cardDetailsInfo.tenantId = this.userSession.tenantId;
        this.cardDetailsInfo.enterpriseId = this.userSession.enterpriseId;
        this.cardDetailsInfo.storeId = this.userSession.storeId;
        this.cardDetailsInfo.returnUrl = window.location.href;
        this.cardDetailsInfo.customerName = this.addcustomerModel.customerName;
        this.cardDetailsInfo.loggedInUserId = this.userSession.sessionUserId;
        if (res.isSuccess) {
          var form = document.getElementById('squareFormSubmit');
          form.click();
        } else if (!res.isSuccess) {
          if (res.message != '') {
            this.showAlert(false, res.message);
            this.addCustomerDialog.action.disable = false;
          } else {
            this.showAlert(false, 'Customer Can not be created');
            this.addCustomerDialog.action.disable = false;
          }
        }
      } finally {
        this.addCustomerDialog.model = false;
        this.addCustomerDialog.action.disable = false;
        this.addcustomerModel = {};
        this.onClose();
      }
    }
  }
}
export default CardsAddressDetails;

